module.exports = __webpack_public_path__ + "static/media/728x90_0006_ru.3cbb382c.png";